import feed from './feed'
import feedSettings from './feedSettings'
import announcements from './announcements'
export default { feed, feedSettings, announcements }
